import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/fullscreen-exit.js
const FullscreenExitIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M10.75 2a.75.75 0 0 1 .75.75V6.5h3.75a.75.75 0 0 1 .743.648L16 7.25a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75" }),
		/* @__PURE__ */ jsx("path", { d: "M14.72 2.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06zM7.25 10a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V11.5H2.75a.75.75 0 0 1-.743-.648L2 10.75a.75.75 0 0 1 .75-.75z" }),
		/* @__PURE__ */ jsx("path", { d: "M6.72 10.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06z" })
	]
});
const ForwardRef = forwardRef(FullscreenExitIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=fullscreen-exit.js.map